import React from "react";

import type { LucideIcon } from "lucide-react";

interface RelationshipEmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  /** Centers in the main content viewport (page-level empty states). */
  centered?: boolean;
}

const RelationshipEmptyState: React.FC<RelationshipEmptyStateProps> = ({
  icon: Icon,
  title,
  description,
  centered = true,
}) => (
  <div
    className={
      centered ? "rl-empty-state rl-empty-state--centered" : "rl-empty-state"
    }
    role="status"
  >
    <div className="rl-empty-state-card">
      <div className="rl-empty-state-icon-wrap" aria-hidden>
        <Icon className="rl-empty-state-icon" />
      </div>
      <h3 className="rl-empty-state-title">{title}</h3>
      {description ? (
        <p className="rl-empty-state-desc">{description}</p>
      ) : null}
    </div>
  </div>
);

export default RelationshipEmptyState;
